module.exports = new __parcel__URL__("webcam-map.39b9a9ff.svg").toString();